import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { describeError } from '@f/error-decorators';

import BaseErrorCallout from './components/BaseErrorCallout';

function getErrorComponent(ErrorComponent) {
  return class extends PureComponent {
    static propTypes = {
      error: PropTypes.shape({
        name: PropTypes.string,
        code: PropTypes.number,
        className: PropTypes.string,
        data: PropTypes.shape({
          type: PropTypes.string.isRequired,
          payload: PropTypes.object,
        }),
      }),
    };

    render() {
      const { error, customTemplates, ...restProps } = this.props;

      if (!error) {
        return null;
      }

      const describedError = describeError(error, { customTemplates, ...restProps });

      return <ErrorComponent describedError={describedError} {...restProps} />;
    }
  };
}

export const ErrorCallout = getErrorComponent(BaseErrorCallout);
